module.exports = __webpack_public_path__ + "static/media/tides-poster.88064b5a.png";